import React, { useState, useEffect } from "react";
import {
  Download,
  Check,
  Smartphone,
  Shield,
  Trophy,
  Star,
  ChevronRight,
} from "lucide-react";

export default function DownloadPage() {
  const [downloading, setDownloading] = useState(false);
  const [countdown, setCountdown] = useState(0);
  const [activeTab, setActiveTab] = useState("features");

  const img_url =
    "https://firebasestorage.googleapis.com/v0/b/towin-fe4cc.appspot.com/o/logoBlgo%2Fnuevo%20logo.png?alt=media&token=5bcd17e0-99cd-4e7c-a45b-d2928a449a40v0/b/towin-fe4cc.appspot.com/o/dproblog%2FDeportivosPro%20Logo.png?alt=media&token=43c88d46-3cc5-4eba-936c-1200cfbda9d4";

  useEffect(() => {
    if (downloading && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (downloading && countdown === 0) {
      setDownloading(false);
    }
  }, [downloading, countdown]);

  const handleDownload = () => {
    setDownloading(true);
    setCountdown(2);
  };
  const handlePlayStore = () => {
    window.location.href =
      "https://play.google.com/store/apps/details?id=online.matubyte.deportivospro&pcampaignid=web_share";
  };

  // Play Store Icon SVG
  const PlayStoreIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
      <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.61 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
    </svg>
  );

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b text-white pb-14">
      <div className="max-w-lg mx-auto w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold bg-gradient-to-r from-green-400 to-blue-500 bg-clip-text text-transparent">
            ¡Descarga DeportivosPro!
          </h1>
          <p className="text-gray-300 mt-2">
            Ahora oficialmente en Google Play Store
          </p>
          <div className="flex items-center justify-center mt-2">
            <div className="bg-green-500 rounded-full p-1 mr-2">
              <Check size={12} className="text-white" />
            </div>
            <span className="text-green-400 text-sm font-medium">
              Aplicación Verificada
            </span>
          </div>
        </div>

        {/* Main Card */}
        <div className="bg-gray-800 rounded-xl p-6 mb-8 shadow-xl border border-gray-700">
          <div className="flex items-center mb-6">
            <div className="w-1/4">
              <img
                src={img_url}
                alt="Logo de DeportivosPro"
                className="w-16 h-16 mx-auto rounded-lg"
              />
            </div>
            <div className="w-3/4 pl-4">
              <h2 className="text-2xl font-bold">DeportivosPro</h2>
              <div className="flex items-center mt-1">
                <div className="flex">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star
                      key={star}
                      size={14}
                      className="text-yellow-400 fill-yellow-400"
                    />
                  ))}
                </div>
                <span className="text-gray-300 text-xs ml-2">
                  5.0 (500+ descargas)
                </span>
              </div>
              <p className="text-gray-300 text-sm mt-1">Versión 3.0.1.8</p>
              <div className="flex items-center mt-1">
                <PlayStoreIcon />
                <span
                  // Click={handlePlayStore}
                  className="text-green-400 text-xs ml-1"
                >
                  Google Play Store
                </span>
              </div>
            </div>
          </div>

          {/* Tabs */}
          <div className="flex border-b border-gray-700 mb-4">
            <button
              className={`px-4 py-2 text-sm font-medium ${
                activeTab === "features"
                  ? "text-blue-400 border-b-2 border-blue-400"
                  : "text-gray-400"
              }`}
              onClick={() => setActiveTab("features")}
            >
              Características
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium ${
                activeTab === "requirements"
                  ? "text-blue-400 border-b-2 border-blue-400"
                  : "text-gray-400"
              }`}
              onClick={() => setActiveTab("requirements")}
            >
              Requisitos
            </button>
            <button
              className={`px-4 py-2 text-sm font-medium ${
                activeTab === "benefits"
                  ? "text-blue-400 border-b-2 border-blue-400"
                  : "text-gray-400"
              }`}
              onClick={() => setActiveTab("benefits")}
            >
              Beneficios
            </button>
          </div>

          {/* Tab Content */}
          <div className="mb-6">
            {activeTab === "features" && (
              <div className="space-y-3">
                <div className="flex items-start">
                  <Trophy size={18} className="text-yellow-500 mr-2 mt-1" />
                  <div>
                    <p className="text-white font-medium">
                      Resultados en directo
                    </p>
                    <p className="text-gray-400 text-sm">
                      Sigue los eventos deportivos en tiempo real
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Star size={18} className="text-blue-400 mr-2 mt-1" />
                  <div>
                    <p className="text-white font-medium">
                      Análisis estadísticos
                    </p>
                    <p className="text-gray-400 text-sm">
                      Estadísticas avanzadas y análisis de rendimiento
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Shield size={18} className="text-green-500 mr-2 mt-1" />
                  <div>
                    <p className="text-white font-medium">
                      Sin publicidad molesta
                    </p>
                    <p className="text-gray-400 text-sm">
                      Experiencia limpia y sin interrupciones
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Smartphone size={18} className="text-purple-400 mr-2 mt-1" />
                  <div>
                    <p className="text-white font-medium">
                      Notificaciones push
                    </p>
                    <p className="text-gray-400 text-sm">
                      Mantente informado de tus equipos favoritos
                    </p>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "requirements" && (
              <div className="space-y-3">
                <div className="flex items-start">
                  <Smartphone size={18} className="text-blue-400 mr-2 mt-1" />
                  <div>
                    <p className="text-white font-medium">
                      Android 6.0 o superior
                    </p>
                    <p className="text-gray-400 text-sm">
                      Compatible con la mayoría de dispositivos actuales
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Check size={18} className="text-green-500 mr-2 mt-1" />
                  <div>
                    <p className="text-white font-medium">
                      25 MB de espacio libre
                    </p>
                    <p className="text-gray-400 text-sm">
                      Aplicación optimizada con nuevas funciones
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Check size={18} className="text-green-500 mr-2 mt-1" />
                  <div>
                    <p className="text-white font-medium">
                      Conexión a internet
                    </p>
                    <p className="text-gray-400 text-sm">
                      Para obtener datos en tiempo real
                    </p>
                  </div>
                </div>
              </div>
            )}

            {activeTab === "benefits" && (
              <div className="space-y-3">
                <div className="flex items-start">
                  <div className="w-5 h-5 mr-2 mt-1">
                    <PlayStoreIcon />
                  </div>
                  <div>
                    <p className="text-white font-medium">
                      Descarga segura oficial
                    </p>
                    <p className="text-gray-400 text-sm">
                      Verificada por Google Play Protect
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Check size={18} className="text-blue-400 mr-2 mt-1" />
                  <div>
                    <p className="text-white font-medium">
                      Actualizaciones automáticas
                    </p>
                    <p className="text-gray-400 text-sm">
                      Siempre tendrás la última versión
                    </p>
                  </div>
                </div>
                <div className="flex items-start">
                  <Shield size={18} className="text-purple-400 mr-2 mt-1" />
                  <div>
                    <p className="text-white font-medium">
                      Soporte técnico oficial
                    </p>
                    <p className="text-gray-400 text-sm">
                      Atención directa desde Google Play
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Download Button */}
          {downloading ? (
            <div className="bg-green-600 text-white font-medium py-3 px-6 rounded-lg w-full text-center">
              {countdown > 0 ? (
                `Redirigiendo a Play Store en ${countdown}...`
              ) : (
                <span className="flex items-center justify-center">
                  <Check className="mr-2" size={20} /> ¡Redirigiendo!
                </span>
              )}
            </div>
          ) : (
            <a
              href="https://play.google.com/store/apps/details?id=online.matubyte.deportivospro&pcampaignid=web_share"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleDownload}
              className="flex items-center justify-center bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700 text-white font-medium py-3 px-6 rounded-lg transition-all duration-300 w-full shadow-lg shadow-green-900/20 transform hover:scale-105"
            >
              <PlayStoreIcon />
              <span className="ml-2">Descargar desde Play Store</span>
            </a>
          )}

          <p className="text-xs text-gray-400 mt-4 text-center">
            ✓ Aplicación oficial verificada por Google
          </p>
        </div>

        {/* FAQ Section */}
        <div className="bg-gray-800 rounded-xl p-6 shadow-xl border border-gray-700">
          <h3 className="font-bold text-lg mb-4 text-center">
            Preguntas Frecuentes
          </h3>

          <div className="space-y-4">
            <div className="border-b border-gray-700 pb-3">
              <div className="flex justify-between items-center">
                <p className="font-medium">
                  ¿Es seguro descargar desde Play Store?
                </p>
                <ChevronRight size={16} className="text-gray-400" />
              </div>
              <p className="text-gray-400 text-sm mt-1">
                Absolutamente. Google Play Store garantiza la seguridad de todas
                las aplicaciones.
              </p>
            </div>

            <div className="border-b border-gray-700 pb-3">
              <div className="flex justify-between items-center">
                <p className="font-medium">¿La app es gratuita?</p>
                <ChevronRight size={16} className="text-gray-400" />
              </div>
              <p className="text-gray-400 text-sm mt-1">
                Sí, DeportivosPro es completamente gratuita con todas sus
                funciones.
              </p>
            </div>

            <div className="border-b border-gray-700 pb-3">
              <div className="flex justify-between items-center">
                <p className="font-medium">¿Hay versión para iOS?</p>
                <ChevronRight size={16} className="text-gray-400" />
              </div>
              <p className="text-gray-400 text-sm mt-1">
                Próximamente en App Store. Mantente atento a nuestras redes.
              </p>
            </div>

            <div>
              <div className="flex justify-between items-center">
                <p className="font-medium">¿Cómo actualizo la app?</p>
                <ChevronRight size={16} className="text-gray-400" />
              </div>
              <p className="text-gray-400 text-sm mt-1">
                Las actualizaciones son automáticas desde Google Play Store.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
